import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// row index should less or equal to (rows.length - ROW_MAX_INDEX_OFFSET)
// consider there is only one row with height 40, the rows should be [0, 40];
var ROW_MAX_INDEX_OFFSET = 2;
var FOOTER_OFFSET = 1;

var IndexPathPositionMap = /*#__PURE__*/function () {
  function IndexPathPositionMap() {
    _classCallCheck(this, IndexPathPositionMap);

    _defineProperty(this, "_header", void 0);

    _defineProperty(this, "_footer", void 0);

    _defineProperty(this, "_sections", void 0);

    this._header = {
      start: 0,
      end: 0
    };
    this._footer = {
      start: 0,
      end: 0
    }; // section: {
    //  start: 0, end: 50,
    //  header: { start: 0, end: 10 },
    //  // just number to save storage
    //  rows: [10, 20, 30],
    //  footer: {start: 30, end: 50}
    // }

    this._sections = [];
  }

  _createClass(IndexPathPositionMap, [{
    key: "clear",
    value: function clear() {
      this._header = {
        start: 0,
        end: 0
      };
      this._sections.length = 0;
      this._footer = {
        start: 0,
        end: 0
      };
    }
  }, {
    key: "setHeaderHeight",
    value: function setHeaderHeight(height) {
      var originHeight = this.getHeaderHeight();

      if (height === originHeight) {
        return;
      }

      this._header.end = height;

      this._addOffsetFrom(0, height - originHeight);
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      return this._header.end - this._header.start;
    }
  }, {
    key: "getHeaderHeightRange",
    value: function getHeaderHeightRange() {
      return [this._header.start, this._header.end];
    }
  }, {
    key: "setFooterHeight",
    value: function setFooterHeight(height) {
      var originHeight = this.getFooterHeight();

      if (height === originHeight) {
        return;
      }

      var lastSection = this._sections[this._sections.length - 1];
      var start = lastSection ? lastSection.end : this._header.end;
      this._footer.start = start;
      this._footer.end = start + height;
    }
  }, {
    key: "getFooterHeight",
    value: function getFooterHeight() {
      return this._footer.end - this._footer.start;
    }
  }, {
    key: "getFooterHeightRange",
    value: function getFooterHeightRange() {
      return [this._footer.start, this._footer.end];
    }
  }, {
    key: "_getAndCreateSection",
    value: function _getAndCreateSection(sectionIndex) {
      var preSection = this._sections[sectionIndex - 1];
      var sectionStartValue = preSection ? preSection.end : this._header.end;
      var section = this._sections[sectionIndex] || {
        header: {
          start: sectionStartValue,
          end: sectionStartValue
        },
        footer: {
          start: sectionStartValue,
          end: sectionStartValue
        },
        start: sectionStartValue,
        end: sectionStartValue,
        rows: []
      };
      this._sections[sectionIndex] = section;
      return section;
    }
  }, {
    key: "setSectionHeaderHeight",
    value: function setSectionHeaderHeight(sectionIndex, height) {
      var section = this._getAndCreateSection(sectionIndex);

      var offset = height - (section.header.end - section.header.start);
      section.header.start = section.start;
      section.header.end = section.header.start + height;

      this._addOffsetInSectionFromRow(section, 0, offset);

      this._addOffsetFrom(sectionIndex + 1, offset);
    }
  }, {
    key: "getSectionHeaderRangeAt",
    value: function getSectionHeaderRangeAt(sectionIndex) {
      var section = this._sections[sectionIndex];

      if (!section) {
        return [0, 0];
      }

      return [section.header.start, section.header.end];
    }
  }, {
    key: "getSectionRangeAt",
    value: function getSectionRangeAt(sectionIndex) {
      var section = this._sections[sectionIndex];

      if (!section) {
        return [0, 0];
      }

      return [section.start, section.end];
    }
  }, {
    key: "setSectionFooterHeight",
    value: function setSectionFooterHeight(sectionIndex, height) {
      var section = this._getAndCreateSection(sectionIndex);

      var offset = height - (section.footer.end - section.footer.start);
      section.footer.start = section.rows[section.rows.length - 1] || section.header.end;
      section.footer.end = section.footer.start + height;
      section.end = section.footer.end;

      this._addOffsetFrom(sectionIndex + 1, offset);
    }
  }, {
    key: "getSectionFooterRangeAt",
    value: function getSectionFooterRangeAt(sectionIndex) {
      var section = this._sections[sectionIndex];

      if (!section) {
        return [0, 0];
      }

      return [section.footer.start, section.footer.end];
    } // TODO test for all case

  }, {
    key: "setItemHeight",
    value: function setItemHeight(indexPath, height) {
      var [top, bottom] = this.getHeightRangeAt(indexPath);
      var originHeight = bottom - top;
      var {
        section: sectionIndex,
        row: rowIndex
      } = indexPath;

      var section = this._getAndCreateSection(sectionIndex);

      if (originHeight === height && rowIndex <= section.rows.length - ROW_MAX_INDEX_OFFSET) {
        return;
      }

      var offset;
      var rows = section.rows;

      if (rowIndex === 0) {
        rows[0] = section.header.end;
      }

      if (rows[rowIndex + 1]) {
        offset = height - (rows[rowIndex + 1] - rows[rowIndex]);
      } else {
        offset = height;
      }

      rows[rowIndex + 1] = rows[rowIndex] + height;

      this._addOffsetInSectionFromRow(section, rowIndex + ROW_MAX_INDEX_OFFSET, offset);

      this._addOffsetFrom(sectionIndex + 1, offset);
    }
  }, {
    key: "_addOffsetInSectionFromRow",
    value: function _addOffsetInSectionFromRow(section, row, offset) {
      var {
        rows,
        footer: sectionFooter
      } = section;
      var numberOfRows = rows.length;

      for (var i = row; i < numberOfRows; i++) {
        rows[i] += offset;
      }

      sectionFooter.start += offset;
      sectionFooter.end += offset;
      section.end += offset;
    }
  }, {
    key: "_addOffsetFrom",
    value: function _addOffsetFrom(sectionIndex, offset) {
      var numberOfSections = this._sections.length;

      for (var i = sectionIndex; i < numberOfSections; i++) {
        var section = this._sections[i];
        section.start += offset;
        section.header.start += offset;
        section.header.end += offset;

        this._addOffsetInSectionFromRow(section, 0, offset);
      }

      this._footer.start += offset;
      this._footer.end += offset;
    }
  }, {
    key: "getTotalHeight",
    value: function getTotalHeight() {
      return this._footer.end;
    }
  }, {
    key: "getHeightRangeAt",
    value: function getHeightRangeAt(indexPath) {
      var {
        section: sectionIndex,
        row
      } = indexPath;
      var section = this._sections[sectionIndex];

      if (!section) {
        return [0, 0];
      }

      if (row > section.rows.length - ROW_MAX_INDEX_OFFSET) {
        return [0, 0];
      }

      return [section.rows[row] || 0, section.rows[row + 1] || 0];
    }
  }, {
    key: "getHeightAt",
    value: function getHeightAt(indexPath) {
      if (!indexPath) {
        return 0;
      }

      var heightRange = this.getHeightRangeAt(indexPath);
      return heightRange[1];
    }
  }, {
    key: "isHeaderVisible",
    value: function isHeaderVisible(y) {
      return y >= this._header.start && y <= this._header.end;
    }
  }, {
    key: "isFooterVisible",
    value: function isFooterVisible(y) {
      // 如果页面高度为小数时（部分windows下的webview内），计算y可能到达不了_footer.start，增加1px的offset
      return y >= this._footer.start - FOOTER_OFFSET;
    }
  }, {
    key: "findIndexPathByPosition",
    value: function findIndexPathByPosition(y) {
      if (!this._sections.length) {
        return null;
      }

      var sectionIndex = this._searchSection(this._sections, y);

      var row = this._searchRow(this._sections[sectionIndex], y);

      return _objectSpread({
        section: sectionIndex
      }, row);
    }
  }, {
    key: "_searchRow",
    value: function _searchRow(section, value) {
      var {
        header,
        footer,
        rows
      } = section;
      var ret = {
        row: -1
      };

      if (value < header.end) {
        // section header和first row绑定，简化后续逻辑
        ret.row = 0;
      } else if (value >= footer.start) {
        // section footer和last row绑定，简化后续逻辑
        ret.row = Math.max(0, rows.length - ROW_MAX_INDEX_OFFSET);
      } else {
        var startIndex = 0;
        var endIndex = rows.length - ROW_MAX_INDEX_OFFSET;

        while (startIndex <= endIndex) {
          var middleIndex = startIndex + endIndex >> 1;

          if (value < rows[middleIndex + 1] && value >= rows[middleIndex]) {
            ret.row = middleIndex;
            break;
          } else if (value < rows[middleIndex]) {
            endIndex = middleIndex - 1;
          } else {
            startIndex = middleIndex + 1;
          }
        }
      }

      return ret;
    }
  }, {
    key: "_searchSection",
    value: function _searchSection(arr, value) {
      var ln = arr.length;
      var startIndex = 0;
      var endIndex = ln - 1;

      if (value <= arr[startIndex].start) {
        return startIndex;
      }

      if (value >= arr[endIndex].end) {
        return endIndex;
      }

      while (startIndex <= endIndex) {
        var middleIndex = startIndex + endIndex >> 1;

        if (value < arr[middleIndex].start) {
          endIndex = middleIndex - 1;
        } else if (value >= arr[middleIndex].end) {
          startIndex = middleIndex + 1;
        } else {
          return middleIndex;
        }
      } // should never reach here cause sections are continuous


      throw new Error("position map invalid: ".concat(value));
    }
  }]);

  return IndexPathPositionMap;
}();

export { IndexPathPositionMap as default };